import { render, staticRenderFns } from "./Soggetti.vue?vue&type=template&id=60f6fc4e"
import script from "./Soggetti.vue?vue&type=script&lang=js"
export * from "./Soggetti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports